import React from 'react';
import { WorkflowWrapper } from '../../../../Workflow/Workflow.styles';
import { Card } from '../../../../CommonComponents/OPL/Card/Card';
import { WorkflowAccountsHeader } from '../../../../Workflow/components/WorkflowAccountsHeader/WorkflowAccountsHeader';
import { Separator } from '../../../../CommonComponents/OPL/Separator/Separator';
import { AccountsWrapper } from '../../Accounts.styles';

interface Wrapper {
  isWorkflow?: boolean;
  children: React.ReactNode;
}

export const Wrapper = ({ isWorkflow, children }: Wrapper) => {
  if (isWorkflow) {
    return (
      <WorkflowWrapper>
        <Card p="32">
          <WorkflowAccountsHeader />

          <Separator my="32" />

          {children}
        </Card>
      </WorkflowWrapper>
    );
  }

  return <AccountsWrapper>{children}</AccountsWrapper>;
};
